import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';

import { createWorkflowUpdatesChangeExtension } from './workflow-updates-change';

interface FlagsData {
  flag?: string | null;
  [key: string]: unknown;
}

const getFlagDisplayName = (flagName: string | null | undefined) => {
  if (!flagName) return '';
  return extractLastNameComponent(flagName) ?? flagName;
};

const FlagsChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as FlagsData | null;
  const newValue = change.newValue as FlagsData | null;

  const oldFlag = oldValue?.flag;
  const newFlag = newValue?.flag;

  const flagAdded = !oldFlag && !!newFlag;
  const flagRemoved = !!oldFlag && !newFlag;

  if (flagAdded || flagRemoved) {
    return (
      <ActivityItem.Section label={flagAdded ? 'Added flag' : 'Removed flag'}>
        <ActivityTagItem
          tagLabel={getFlagDisplayName(flagAdded ? newFlag : oldFlag)}
          ariaLabel="Flag name"
        />
      </ActivityItem.Section>
    );
  }

  return (
    <ActivityItem.Section label="Changed flag">
      <ActivityTagItem
        oldValue={getFlagDisplayName(oldFlag)}
        newValue={getFlagDisplayName(newFlag)}
        ariaLabel="Flag name"
      />
    </ActivityItem.Section>
  );
};

export interface CreateUpdateFlagsExtensionOptions {
  id: string;
  fieldPath: string;
}

export const createUpdateFlagsExtension = (
  options: CreateUpdateFlagsExtensionOptions,
) => {
  return createWorkflowUpdatesChangeExtension({
    id: options.id,
    predicate: ({ change }) => {
      if (change.fieldPath !== options.fieldPath) return false;
      const oldFlag = (change.oldValue as FlagsData | null)?.flag;
      const newFlag = (change.newValue as FlagsData | null)?.flag;
      return (
        (!oldFlag && !!newFlag) ||
        (!!oldFlag && !newFlag) ||
        (!!oldFlag && !!newFlag && oldFlag !== newFlag)
      );
    },
    render: FlagsChangeRender,
  });
};
